import styled from 'styled-components';
import { FunctionComponent } from 'react';
import { FormProps } from 'antd/lib/form';
import Form from 'antd/lib/form';

interface FormWithProps extends FormProps {
  readOnly?: boolean;
}

export const ProposalStyled = styled.div`
  .proposal-form-header {
    margin-bottom: 1rem;
  }
  h2 {
    padding: 0;
    margin: 0;
  }
`;

const marginForLastFormItem = '30px';
export const ProposalFormStyled: FunctionComponent<FormWithProps> = styled(Form)`
  display: flex;
  align-items: center;
  padding-left: 0.8rem;
  margin-bottom: 1rem;
  .ant-form-item {
    cursor: ${(props: FormWithProps) =>
      props.readOnly ? 'not-allowed !important' : 'inherit'};
    .ant-form-item-control {
      pointer-events: ${(props: FormWithProps) =>
        props.readOnly ? 'none !important' : 'inherit'};
    }
  }
`;

export const ProposalButtons = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  flex: 1 0 80%;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 1rem;
  background: white;
  a,
  button:not(:last-child) {
    margin-right: ${marginForLastFormItem};
  }
`;
